module.exports = __webpack_public_path__ + "img/大通道.417533eb.png";